// CategoryTag.tsx
import React from 'react'
import Badge from 'react-bootstrap/Badge'

interface CategoryTagProps {
  category: string
}

const CategoryTag: React.FC<CategoryTagProps> = ({ category }) => {
  return <Badge className="category-badge text-category-gray">{category}</Badge>
}

export default CategoryTag
